import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class FaqCarousel extends HTMLElement {
  constructor() {
    super();

    // bindings

    // privates
    this._node = this;
    this._swiper_el = this._node.querySelector(".faq-carousel-swiper");
    this._pagination = this._node.querySelector(".pagination");
    this._prev = this._node.querySelector('.arrow.prev');
    this._next = this._node.querySelector('.arrow.next');

    // events
    this._swiper = new Swiper(this._swiper_el, {
      a11y: false,
      speed: 333,
      loop: false,
      draggable: true,
      autoHeight: false,
      slidesPerView: 'auto',
      watchOverflow: true,
      navigation: {
        prevEl: this._prev,
        nextEl: this._next
      },
      pagination: {
        el: this._pagination,
        clickable: true
      },
      keyboard: {
        enabled: false
      }
    });
  }

  /**
   * Handle unmount.
   */
   disconnectedCallback() {
  }
}
